import React from "react";
import {
  BtnBold,
  BtnBulletList,
  BtnClearFormatting,
  BtnItalic,
  BtnLink,
  BtnNumberedList,
  BtnRedo,
  BtnStrikeThrough,
  BtnUnderline,
  BtnUndo,
  Editor,
  EditorProvider,
  Toolbar,
} from "react-simple-wysiwyg";

const RichTextEditor = ({ value, onChange, placeholder, rows = 6 }) => {
  return (
    <div className="rich-text-editor-container">
      <EditorProvider>
        <Editor
          value={value || ""}
          onChange={(e) => {
            onChange(e?.target?.value || "");
          }}
          placeholder={placeholder}
          style={{
            minHeight: `${rows * 24}px`,
            border: "1px solid #d9d9d9",
            borderRadius: "6px",
            padding: "8px 12px",
            fontSize: "14px",
            lineHeight: "1.5",
            fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif"
          }}
        >
          <Toolbar>
            <BtnBold />
            <BtnItalic />
            <BtnUnderline />
            <BtnStrikeThrough />
            <BtnClearFormatting />
            <BtnBulletList />
            <BtnNumberedList />
            <BtnLink />
            <BtnUndo />
            <BtnRedo />
          </Toolbar>
        </Editor>
      </EditorProvider>
    </div>
  );
};

export default RichTextEditor;
